const getErrors = state => state.banner.errors;
export const getLoadBannersError = state => getErrors(state).loadBannersError;
export const getExchangeBannerError = state => getErrors(state).exchangeBannerError;
export const getBannerError = state => getErrors(state).bannerError;
export const getDeleteBannerError = state => getErrors(state).deleteBannerError;
